import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { Card, Typography, Collapse, Icon } from "antd";
import {
  selectCurrentUserGroupKey,
  selectCurrentUser
} from "../../../redux/selectors/auth";
import {
  selectAllPreguntas,
  selectHighestPregunta
} from "../../../redux/selectors/actividades";
import ActividadIndividual from "./ActividadIndividual";

class Actividades extends PureComponent {
  render() {
    const {
      currentUser,
      group,
      preguntasByEtapa,
      highestPregunta
    } = this.props;

    return (
      <Card style={{ padding: 30 }}>
        <Collapse
          expandIcon={({ isActive }) => (
            <Icon type="caret-right" rotate={isActive ? 90 : 0} />
          )}
          defaultActiveKey={
            (highestPregunta && highestPregunta.indexEtapa) || 0
          }
        >
          <Collapse.Panel
            header={
              <Typography.Title level={2}>
                1. Identificar la Aventura
              </Typography.Title>
            }
          >
            {preguntasByEtapa[0].map(pregunta => {
              return (
                <ActividadIndividual
                  key={Math.random()}
                  pregunta={pregunta}
                  currentUser={currentUser}
                  group={group}
                  {...this.props}
                />
              );
            })}
          </Collapse.Panel>
          <Collapse.Panel
            header={
              <Typography.Title level={2}>
                2. Preparación del Viaje
              </Typography.Title>
            }
          >
            {preguntasByEtapa[1].map(pregunta => {
              return (
                <ActividadIndividual
                  key={Math.random()}
                  pregunta={pregunta}
                  currentUser={currentUser}
                  group={group}
                  {...this.props}
                />
              );
            })}
          </Collapse.Panel>
          <Collapse.Panel
            header={
              <Typography.Title level={2}>
                3. Construir la Mision
              </Typography.Title>
            }
          >
            {preguntasByEtapa[2].map(pregunta => {
              return (
                <ActividadIndividual
                  key={Math.random()}
                  pregunta={pregunta}
                  currentUser={currentUser}
                  group={group}
                  {...this.props}
                />
              );
            })}
          </Collapse.Panel>
          <Collapse.Panel
            header={
              <Typography.Title level={2}>4. Salir a Explorar</Typography.Title>
            }
          >
            {preguntasByEtapa[3].map(pregunta => {
              return (
                <ActividadIndividual
                  key={Math.random()}
                  pregunta={pregunta}
                  currentUser={currentUser}
                  group={group}
                  {...this.props}
                />
              );
            })}
          </Collapse.Panel>
        </Collapse>
      </Card>
    );
  }
}

const mapStateToProps = state => {
  const groupKey = selectCurrentUserGroupKey(state);
  const currentUser = selectCurrentUser(state);
  const allPreguntas = selectAllPreguntas(state);
  const preguntasByGrupo = allPreguntas.filter(
    pregunta => pregunta.nivel === currentUser.nivel
  );
  const highestPregunta = selectHighestPregunta(state);

  let preguntasByEtapa = {
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: [],
    7: []
  };
  preguntasByGrupo &&
    preguntasByGrupo.map(pregunta => {
      if (pregunta.indexEtapa === 0) {
        preguntasByEtapa = {
          ...preguntasByEtapa,
          0: [...preguntasByEtapa[0], pregunta]
        };
      }
      if (pregunta.indexEtapa === 1) {
        preguntasByEtapa = {
          ...preguntasByEtapa,
          1: [...preguntasByEtapa[1], pregunta]
        };
      }
      if (pregunta.indexEtapa === 2) {
        preguntasByEtapa = {
          ...preguntasByEtapa,
          2: [...preguntasByEtapa[2], pregunta]
        };
      }
      if (pregunta.indexEtapa === 3) {
        preguntasByEtapa = {
          ...preguntasByEtapa,
          3: [...preguntasByEtapa[3], pregunta]
        };
      }
      if (pregunta.indexEtapa === 4) {
        preguntasByEtapa = {
          ...preguntasByEtapa,
          4: [...preguntasByEtapa[4], pregunta]
        };
      }
      if (pregunta.indexEtapa === 5) {
        preguntasByEtapa = {
          ...preguntasByEtapa,
          5: [...preguntasByEtapa[5], pregunta]
        };
      }
      if (pregunta.indexEtapa === 6) {
        preguntasByEtapa = {
          ...preguntasByEtapa,
          6: [...preguntasByEtapa[6], pregunta]
        };
      }
    });

  return {
    highestPregunta,
    preguntasByEtapa,
    currentUser,
    groupKey,
    preguntasByGrupo
  };
};

export default connect(mapStateToProps)(Actividades);
